import { TVedCommonState } from './types';

export function getCountriesTree(state: TVedCommonState) {
  return state.countriesTree;
}

export function getRegionsRfTree(state: TVedCommonState) {
  return state.regionsRfTree;
}

export function getCustomsOrgansOnBorder(state: TVedCommonState) {
  return state.customsOrgansOnBorder;
}

export function getCustomsOrgansOnBorderTree(state: TVedCommonState) {
  return state.customsOrgansOnBorderTree;
}
